export default {
  path: "/pdfH5",
  name: "pdfH5",
  component: () => import("@/views/Page.vue"),
  children: []
};
